import * as yup from 'yup';
import { useTranslations } from 'hooks/useTranslations';

export const Schema = () => {
  const { t } = useTranslations();

  return yup.object({
    measurement: yup.string().nullable().required(t('general.field.validation.required')),
    currency: yup.string().nullable().required(t('general.field.validation.required')),
  });
};
